import { VacationRequestCard } from '../../../components/VacationRequestList/components/VacationRequestCard';
import { buildTourDemoRequest } from './tourDemo.definitions';

export function TourDemoRequestCard() {
    const demoRequest = buildTourDemoRequest(new Date());

    return (
        <ul className="space-y-3">
            <VacationRequestCard request={demoRequest} onSelect={() => {}} />
        </ul>
    );
}

export default TourDemoRequestCard;
